export default {
  namespaced: true,
  state: {
    notifications: [],
    count: 0,
  },
  getters: {
    getNotifications: (state) => state.notifications,
  },
  mutations: {
    CHANGE_COUNT(state) {
      state.count++;
    },
    ADD_NOTIFICATION(state, notification) {
      state.notifications.push(notification);
    },
    REMOVE_NOTIFICATION(state, notificationId) {
      state.notifications = state.notifications.filter(
        (n) => n.id !== notificationId
      );
    },
  },
  actions: {
    addNotification({ commit, state }, notification) {
      commit("CHANGE_COUNT");
      notification.id = state.count;
      commit("ADD_NOTIFICATION", notification);

      setTimeout(() => {
        commit("REMOVE_NOTIFICATION", notification.id);
      }, 4000);
    },
    removeNotification({ commit }, notificationId) {
      commit("REMOVE_NOTIFICATION", notificationId);
    },
  },
};
